import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import dojoQuery from 'dojo/query';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// template-instantiated child widgets (data-dojo-type) — bare side-effect imports.
import "../../../more/HintBox";
import "../../../more/SelectBox";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import template from './TaskExecutionView.html?raw';
import ExecutionChangeDlg from './ExecutionChangeDlg';

class TaskExecutionView extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entityID: any = null;
    jsonEntity: any = null; // Entity wies aus der Datenbank kommt

    _tableFormatter_Material(cell: any): any {
        let rowGroup = cell.tableRow.rowGroup;
        let entity = cell.entity;
        let colname = cell.name;
        let colValue = cell.value;
        let node = cell.tableCellNode;

        switch (colname) {
            case "Quantity":
                if (entity.ref_quantity_unit?.Name) {
                    colValue += " " + entity.ref_quantity_unit.Name;
                    node.innerHTML = colValue;
                    return true;
                }
                break;

            case "Summe":
                if (colValue) {
                    colValue = "€ " + colValue;
                } else {
                    colValue = "?";
                }

                if (entity.Unit_price && entity.ref_quantity_unit?.Name) {
                    colValue += " (€ " + entity.Unit_price + "/" + entity.ref_quantity_unit?.Name + ")";
                }
                node.innerHTML = colValue;
                return true;

                break;
        }

        return false;
    }
    _tableFormatter_Flatrate(cell: any): any {
        let rowGroup = cell.tableRow.rowGroup;
        let entity = cell.entity;
        let colname = cell.name;
        let colValue = cell.value;
        let node = cell.tableCellNode;

        switch (colname) {
            case "Quantity":
                if (entity.ref_vt_flat_rate?.ref_unit?.display_unit) {
                    colValue += " " + entity.ref_vt_flat_rate?.ref_unit?.display_unit;
                    node.innerHTML = colValue;
                    return true;
                }
                break;

            case "Summe":
                if (colValue) {
                    colValue = "€ " + colValue;
                } else {
                    colValue = "?";
                }

                if (entity.price_unit && entity.ref_vt_flat_rate?.ref_unit?.display_unit) {
                    colValue += " (€ " + entity.price_unit + "/" + entity.ref_vt_flat_rate?.ref_unit?.display_unit + ")";
                }
                node.innerHTML = colValue;
                return true;

                break;
        }

        return false;
    }


    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }


    setFormData(data: any, enableActions?: any): void {
        if (data) this.jsonEntity = data;
        this.entityID = this.jsonEntity.ID;

        this.hideNode(this.actionContainer, enableActions !== true);
        this.hideNode(this.approvalActionContainer, enableActions !== true);

        if ((window as any).taskApprovalSubstitution) {
            this.jsonEntity.substitutionEmployee = (window as any).taskApprovalSubstitution.ID;
            this.hideNode(this.sectionSubstitution, false);
            domAttr.set(this.sectionSubstitution, "innerHTML", this.translations["TaskApproval__SubstitutionActiveMessage"].format((window as any).taskApprovalSubstitution.label));
        }

        //console.info(this.id + " setFormData", this.jsonEntity);

        var inputs: any = dojoQuery("[data-evisattribute]", this.entityContainer);
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            var value = this.PitHelper.getEntityAttributeValue(this.jsonEntity, input.dataset["evisattribute"], "json");

            let format = input.dataset.dateformat;
            if (format && value) {
                if (typeof (value) == "string") value = new Date(value);

                value = this.dateToString(value, format);
            }

            if (value) domAttr.set(input, "innerHTML", value);

        }

        if (this.jsonEntity.is_approval_yes) {
            domClass.replace(this.btnApprove, "w3-text-green", "w3-green");

            this.hideNode(this.sectionCurrentApprovalStatus, false);
            domClass.add(this.sectionCurrentApprovalStatus, "w3-pale-green");
            domAttr.set(this.sectionCurrentApprovalStatus, "innerHTML",
                this.translations["TaskApproval__StatusText_Approved"].format(
                    this.jsonEntity.ref_approved_by ? this.jsonEntity.ref_approved_by.DispName : "-?-",
                    this.jsonEntity.date_approval ? this.dateToString(new Date(this.jsonEntity.date_approval), "dd.MM.yyyy HH:mm") : "-?-",
                )
            );
        }
        if (this.jsonEntity.is_approval_no) {
            domClass.replace(this.btnReject, "w3-text-red", "w3-red");

            this.hideNode(this.sectionCurrentApprovalStatus, false);
            domClass.add(this.sectionCurrentApprovalStatus, "w3-pale-red");
            domAttr.set(this.sectionCurrentApprovalStatus, "innerHTML",
                this.translations["TaskApproval__StatusText_Rejected"].format(
                    this.jsonEntity.ref_approved_by ? this.jsonEntity.ref_approved_by.DispName : "-?-",
                    this.jsonEntity.date_approval ? this.dateToString(new Date(this.jsonEntity.date_approval), "dd.MM.yyyy HH:mm") : "-?-",
                )
            );
        }

        this.drawMaterialTable();
        this.drawFlatratesTable();

    }

    drawMaterialTable(): void {
        domConstruct.empty(this.materialTableContainer);

        if (this.jsonEntity?.EL_vt_task_workstep_material_vt_task_executor) {
            let table = new StaticTable();

            table.placeAt(this.materialTableContainer);
            table.setFormatter(lang.hitch(this, this._tableFormatter_Material));
            table.setData(this.jsonEntity.EL_vt_task_workstep_material_vt_task_executor);
            table.setLayout({
                "rows": [
                    {
                        "attributes": [
                            "Name",
                            "Quantity",
                            "Summe",
                            "Note"
                        ],
                        "headings": [
                            "Bezeichnung",
                            "Menge",
                            "Preis",
                            "Anmerkung"
                        ],
                        "colspans": [
                            1,
                            1,
                            1,
                            1
                        ],
                        "widths": [
                            "",
                            "15ch",
                            "10ch",
                            ""
                        ],
                        "colNamesInternal": [
                            "Name",
                            "Quantity",
                            "Summe",
                            "Note"
                        ]
                    }
                ],
                "name": "default",
                "label": "default",
                "layoutStyle": "auto"
            });
        }
    }

    drawFlatratesTable(): void {
        domConstruct.empty(this.flatratesTableContainer);

        if (this.jsonEntity?.EL_ht_flat_rate_appointment_vt_appointment) {
            let table = new StaticTable();

            table.placeAt(this.flatratesTableContainer);
            table.setFormatter(lang.hitch(this, this._tableFormatter_Flatrate));
            table.setData(this.jsonEntity.EL_ht_flat_rate_appointment_vt_appointment);
            table.setLayout({
                "rows": [
                    {
                        "attributes": [
                            "ref_vt_flat_rate.bezeichnung",
                            "quantity",
                            "Gesamtsumme"
                        ],
                        "headings": [
                            "Bezeichnung",
                            "Menge",
                            "Preis"
                        ],
                        "colspans": [
                            1,
                            1,
                            1,
                            1
                        ],
                        "widths": [
                            "",
                            "15ch",
                            "10ch"
                        ],
                        "colNamesInternal": [
                            "Name",
                            "Quantity",
                            "Summe"
                        ]
                    }
                ],
                "name": "default",
                "label": "default",
                "layoutStyle": "auto"
            });
        }
    }

    _onClick_Reject(evt: any): void {
        this._saveApproval(false);
    }
    _onClick_Approve(evt: any): void {
        this._saveApproval(true);
    }

    _saveApproval(bApproval: any): void {
        this.StandbyStart();

        let url = window.appRoot + "TaskApproval/SaveApproval";
        this._isRequestActive = true;

        let data: any = {};

        data.taskExecutionID = this.entityID;

        if (this.jsonEntity.substitutionEmployee) {
            data.substitutionEmployee = this.jsonEntity.substitutionEmployee;
        }

        data.approve = bApproval === true;
        data.reject = bApproval === false;

        var stringData = JSON.stringify(data);

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TaskApproval__SaveExecutionApproval",
            data,
            lang.hitch(this, this._onSaveApprovalResponse),
            lang.hitch(this, this._onSaveApprovalError),
            false // sync
        );
    }

    _onSaveApprovalResponse(response: any): void {
        this.StandbyStop();
        this.emit("change");

    }

    _onSaveApprovalError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
    }

    showStatusChangeDialog(taskEntity: any, header: any, subtitle: any, callback: any): void {
        var dialog = new ExecutionChangeDlg();
        this.executionChangeDlg = dialog;
        dialog.setup(taskEntity, header, subtitle, callback, "-MA-TA-DisableNotes", this.jsonEntity); // Material benutzen für Ergänzungen, umschalten auf TaskApproval-Modus
        dialog.show();
    }

    _onClick_OpenDlg(evt: any): void {

        let taskEntity = this.jsonEntity.ref_Task;

        let header = this.translations["TaskApproval__DialogEditHeading"].format(taskEntity.Number, this.jsonEntity.ref_employee.dispname);
        let subtitle = this.translations["TaskApproval__DialogEditMessage"].format(taskEntity.Number);


        this.showStatusChangeDialog(taskEntity,
            header,
            subtitle,
            lang.hitch(this,
                this._onEditExecution
            )
        );
    }

    _onEditExecution(response: any): void {
        if (response >= 1) {
            this._saveExecutionEdit();
        }
        //    let newData = this.executionChangeDlg.getData();
        //    console.log("_onEditExecution", response, newData);
    }

    _saveExecutionEdit(): void {

        this.StandbyStart();

        let url = window.appRoot + "JDM/SaveMaterial";
        this._isRequestActive = true;

        let data = this.executionChangeDlg.getData();

        data.taskExecutionID = this.entityID;

        if (this.jsonEntity.substitutionEmployee) {
            data.substitutionEmployee = this.jsonEntity.substitutionEmployee;
        }

        var stringData = JSON.stringify(data);

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TaskApproval__SaveMaterial",
            data,
            lang.hitch(this, this._onSaveExecutionEditResponse),
            lang.hitch(this, this._onSaveExecutionEditError),
            false // sync
        );
    }

    _onSaveExecutionEditResponse(response: any): void {

        this.StandbyStop();

        this.emit("change");
    }

    _onSaveExecutionEditError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
    }


    handleErrorResponse(message: any): void {
        if (typeof (this.errorCallback) == "function") {
            this.errorCallback(message);
            return;
        }

        // ansonsten Fehlermeldung selber irgendwo platzieren?
        else {
            alert(message);

            //this.showToast({
            //    title: "Fehler Fehler",
            //    message: message
            //});
        }
    }
}
TaskExecutionView.prototype.declaredClass = 'WidgetCollection.TaskExecution.TaskExecutionView';

export default mdsWidget(TaskExecutionView);
